export const HOME = '/home';
export const ERROR = '/error';
export const MAPPING = '/mapping';
export const ACCOUNTS = '/accounts';
export const ACCOUNT = '/account/:vendor/:id';

export const CONTACTS = '/contacts';
export const CONTACT = '/contact/:vendor/:id';

export const DASHBOARD_REPORT = '/dashboard/report';

export const SALES = '/sales';
export const PARTNERSHIP = '/partnership';

export const DATA = '/data';

export const SETTINGS = '/settings';

export const OPPORTUNITIES = '/opportunities';
export const OPPORTUNITY = '/opportunity/:id';

export const CO_SELL_OPPORTUNITIES = '/co-sell-opportunities';
export const CO_SELL_OPPORTUNITY = '/co-sell-opportunity/:id';

export const HEATMAPS = '/heatmaps';
export const HEATMAP = '/heatmap/:id';

export const CAMPAIGNS = '/campaigns';
export const CAMPAIGN = '/campaign/:id';
export const CAMPAIGN_MEMBERS = '/campaign/:id/members';

export const PROGRAMS = '/programs';
export const PROGRAM = '/program/:id';

export const FUNDS = '/funds';
export const FUND = '/fund/:id';

export const MARKETINGS = '/marketing';
export const MARKETING = '/marketing/:id';

export const USERS = '/users';
export const LICENSE = '/license';
export const DBSNAPSHOTS = '/snapshots';
export const SALESFORCE_MANAGERS = '/salesforce-managers';
export const TEST = '/test';


export const SIGN_IN = '/';
export const FORGOT_PASSWORD = '/forgot';
export const INVITE = '/invite/:hash';
export const INTERNAL_SIGN_IN = '/internal';
// export const INTERNAL_SIGN_IN = '/';

export const BI = '/bi';

export const INTEGRATIONS = '/integrations';
export const HUBSPOT_INTEGRATION = '/integrations/hubspot';
export const SALESFORCE_INTEGRATION = '/integrations/salesforce';
